import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import 'normalize.css/normalize.css'
import header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
Vue.config.productionTip = false
Vue.component('Header',header)
Vue.component('Footer',Footer)
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')